<template>
  <div class="add-wrap">
    <div class="card">
      <div class="card-body">
        <div class="col-md-12">
          <h4 class="card-title">Add Contact</h4>
          <!-- <form @submit.prevent="addUser"> -->
          <div>
            <div class="clearfix">
              <div class="form-row">
                <div class="col-md-4 select-dropdown">
                  <mdb-input label="Area Code" placeholder="eg: +852" v-model="areaCode"/>
                </div>
                <div class="col-md-8">
                  <mdb-input label="Phone Number" :invalid="error.channel_id"
                             placeholder="eg: 99999999"
                             :validation="!!(error.channel_id)"
                             v-model="form.channel_id"
                             :invalid-feedback="error.channel_id"/>
                </div>
              </div>

              <mdb-input label="UserName"
                         :invalid="error.name"
                         v-model="form.name"
                         :validation="!!(error.name)"
                         :invalid-feedback="error.name"/>
            </div>
            <div class="text-center">
              <mdb-btn block v-if="!loadingFlag" type="submit" @click="addUser">Add</mdb-btn>
              <mdb-btn block v-if="loadingFlag" outline="success">Loading...</mdb-btn>
            </div>
          </div>
          <!-- </form> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mdbInput from "mdbvue/src/components/Forms/Input";
import mdbBtn from "mdbvue/src/components/Components/Button";
import userService from "../Services/UserService";

let user = new userService();

export default {
  components: {
    mdbInput,
    mdbBtn
  },
  data() {
    return {
      areaCode: "+852",
      form: {
        channel_id: "",
        name: ""
      },
      error: {
        channel_id: false,
        name: false
      },
      loadingFlag: false
    };
  },

  computed: {
    channel_id() {
      return `${this.areaCode}${this.form.channel_id}`;
    }
  },

  methods: {
    addUser() {
      if (this.loadingFlag) {
        return;
      }
      this.loadingFlag = true;

      user
          .addUser(this.channel_id, this.form.name)
          .then(() => {
            Object.keys(this.error).forEach(k => {
              this.$set(this.error, k, false);
              this.$set(this.form, k, "");
            });

            this.$router.push({
              path: '/'
            });
          })
          .catch(err => {
            Object.keys(this.error).forEach(k => {
              this.$set(this.error, k, false);
            });

            if (err.validate) {
              Object.keys(err.validate).forEach(k => {
                this.$set(this.error, k, err.validate[k][0]);
              });

              return;
            }

            this.error.channel_id = err.msg;
          })
          .finally(() => {
            this.loadingFlag = false;
          });
    }
  }
};
</script>
<style lang="scss">
.add-wrap {
  padding: 1em;
}
</style>
